/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import isEmpty from 'lodash.isempty';
import isUndefined from 'lodash.isundefined';
import get from 'lodash/get';
import has from 'lodash/has';
import {translate} from '@ion/core/src/locale/locale';
import {FormItem} from '@ion/dls/src/components/forms/FormItem';
import Switch from '@ion/dls/src/components/switch/Switch';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';
import {nonFlightModeTypes, pendingValueCheck} from './SCISettingsUtils';

const pendingStatusStyle = {
  width : '20%'
};

export interface SCICustomTabProps {
  deviceModel: string;
  customTabFields: any;
  classes: {
    [key: string]: string;
  };
  handleCustomSwitchChange: Function;
  noUpdate: boolean;
  sciPendingSettingData: any;
  getIsActive: Function
}
/**
 * View or Edit Controls related information of an SCI device
 */
export const SCICustomTab = ({
  deviceModel,
  customTabFields,
  classes,
  handleCustomSwitchChange,
  noUpdate,
  sciPendingSettingData,
  getIsActive
}: SCICustomTabProps) => {
  const nonCustomFields = useCallback((item): boolean => {
    return (item.label === translate('admin-devices:view.sciSettings.flightMode') &&
      nonFlightModeTypes.includes(deviceModel));
  }, []);
  return (
    <div>
      <div >
        <span>{deviceModel}</span>
      </div>
      {customTabFields?.length ? customTabFields.map((item) => {
        if (!nonCustomFields(item)) {
          return (
            <div>
              {Object.entries(item).map(([key, value]) => {
                if (key !== 'label') {
                  return (
                    <div className={classes.flexStyle}>
                      <div className={classes.customTabPaper}>
                        <FormItem fullWidth>
                          <div className={classes.actionsTile}>
                            <BodyTypography className={classes.overridesReportTitle}>
                              {item.label}
                            </BodyTypography>
                            <Switch disabled={noUpdate}
                              name={item.label}
                              onChange={function(e) {
                                handleCustomSwitchChange(e, key);
                              }}
                              checked={getIsActive(value)}/>
                          </div>
                        </FormItem>
                        {!isEmpty(sciPendingSettingData) && has(sciPendingSettingData, key) && (
                          <span className={classes.pendingStatus} style={pendingStatusStyle}>
                            {!isUndefined((get(sciPendingSettingData, key))) && (
                              <span>
                                ({translate('admin-devices:view.sciSettings.pending')}
                                {pendingValueCheck(get(sciPendingSettingData, key))})
                              </span>
                            )}
                          </span>
                        )}
                      </div>
                    </div>);
                }
              })}
            </div>
          );
        }
      }) : <div className={classes.noDataStyle}>{translate('admin-devices:view.sciSettings.noRowsMessage')}</div> }
    </div>
  );
};

export default SCICustomTab;
